interface UserActionsResponse {
  id: number
  name: string
  categoryId: number
}

const isUserActionsResponse = (response: any): response is UserActionsResponse[] => {
  if (response === undefined) {
    return false
  }
  if (!Array.isArray(response)) {
    return false
  }
  if (response.length === 0) {
    return true
  }
  if ('id' in response[0] === false || 'name' in response[0] === false || 'categoryId' in response[0] === false) {
    return false
  }
  return true
}

export type { UserActionsResponse }
export { isUserActionsResponse }
